import React, { ChangeEventHandler, FunctionComponent } from "react";
import InputMask from "react-input-mask";
import { Trans } from "@lingui/macro";
import parse from "date-fns/parse";
import isValid from "date-fns/isValid";

export interface DateChangedEvent {
  value: string | undefined;
  isPartialDate: boolean;
  error?: JSX.Element;
}

const isEmptyDate = (value?: string): value is undefined => !value || value === "__/__/____";
const isPartialDate = (value?: string) => !isEmptyDate(value) && value.includes("_");

const isValidDate = (value: string) => {
  const date = parse(value, "dd/MM/yyyy", new Date());
  return isValid(date);
};

const parseDate = (value?: string): DateChangedEvent => {
  if (isEmptyDate(value)) return { value: undefined, isPartialDate: false };

  return {
    value,
    isPartialDate: isPartialDate(value),
    error: isValidDate(value) ? undefined : <Trans>Geen geldige datum (dd/mm/jjjj)</Trans>,
  };
};

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  onDateChanged?(date: DateChangedEvent): void;
}

export const DateInput: FunctionComponent<Props> = ({ onDateChanged, ...props }) => {
  const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    props.onChange && props.onChange(event);

    onDateChanged && onDateChanged(parseDate(event.target.value));
  };

  return <InputMask {...props} onChange={handleChange} mask="99/99/9999" />;
};

DateInput.displayName = "DateInput";
